export default {"src":"/_next/static/media/handbook-hero-blank.4a78100a.svg","height":240,"width":382,"blurWidth":0,"blurHeight":0};